import { crabDevice, readLocalMesg } from '@hfzq/crab-utils';
import { MallHomeRouteExtra } from '@src/routes/route/extra';

let hasNavigateToHome = false;

/**
 * 获取当前用户的唯一标识符
 *
 */
export async function getUserCode() {
  const { USERCODE, JYLOGINFLAG } = await readLocalMesg(['usercode', 'jyloginflag', 'logintype=1'] as const);
  if (+(JYLOGINFLAG || '0') > 1 && USERCODE) {
    return USERCODE;
  }
  // 如果当前在首页不再执行跳转
  if (!/#\/fundIndex/.test(window.location.href) && !hasNavigateToHome && crabDevice.isTZT) {
    hasNavigateToHome = true;
    MallHomeRouteExtra();
  }

  return '';
}
